import React from "react";
import { PlanningTeamsUrl } from "../../../constants/apiUrls.js";
import DataSourceDropdownComponent from "./DataSourceDropdownComponent.js";

const defaultMapping = t => ({ key: t.id, name: t.description });
const sortByDescription = (a, b) => (a.description > b.description) ? 1 : -1;

const TeamsDropdown = ({
  resources,
  team,
  teams,
  onTeamChange,
  onRequestStart,
  onRequestEnd,
  filter,
  containerClass,
  map = null,
  helperText = null,
  defaultValue = null,
  labelText = null,
  inputName = "team",
  id = "teams-dropdown",
  disabled = false,
  required = false,
}) => {

  return (
    <DataSourceDropdownComponent
      id={id}
      labelText={labelText ??resources["Team"]}
      value={team}
      placeholder={defaultValue ?? resources["All"]}
      values={teams}
      handleChange={onTeamChange}
      inputName={inputName}
      addMarginBottom={false}
      helperText={helperText}
      disabled={disabled}
      required={required}
      onRequestStart={onRequestStart}
      onRequestEnd={onRequestEnd}
      containerClass={containerClass}
      sourceUrl={PlanningTeamsUrl()}
      map={map ?? defaultMapping}
      filter={filter}
      sort={sortByDescription}
    />
  );
};

export default TeamsDropdown;
